export default __webpack_public_path__ + "static/media/3.25f2b00b.png";